import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {CmsCopy} from '../../graphql/common.datatypes';

interface CmsCopyData {
    cmsCopy: CmsCopy
}

export const gqlCmsCopy = `
    id
    key
    body
    is_html
`;

export const GET_CMS_COPY_QUERY = gql`
    query getCmsCopy($id: Int!){
        cmsCopy(id: $id){
          ${gqlCmsCopy}
        }
    }
`;

export const getCmsCopy = (id: number) => {
    return useQuery<CmsCopyData>(
        GET_CMS_COPY_QUERY,
        {
            variables: {id},
        }
    );
};

export default getCmsCopy;
